<template>
  <div id="app">
    <router-view :key="$route.fullPath"></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
</style>

<style lang="stylus">
  @import './stylus/main'

  // #app {
  //   font-family: 'Avenir', Helvetica, Arial, sans-serif;
  //   -webkit-font-smoothing: antialiased;
  //   -moz-osx-font-smoothing: grayscale;
  //   color: #2c3e50;
  //   margin-top: 60px;
  // }
  // img#logo {
  //   display: block;
  //   margin-left: auto;
  //   margin-right: auto;
  // }
  // .filter-bar {
  //   padding: 8px;
  // }
  // .pagination {
  //   margin-top: 0px;
  // }
</style>



// WEBPACK FOOTER //
// App.vue?1df90c54